<template>
    <router-view></router-view>
</template>

<script>


export default {
    name: 'App',

}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 10px;
    padding: 0 1rem;
}

</style>
